import {
  RugbyLeagueEventStatusId,
  RugbyLeagueIncidentId,
} from '@collector/sportsapi-client-legacy'

import { IncidentsResultConfig } from '../../../configuration'

export const incidentsResultConfig: IncidentsResultConfig<RugbyLeagueIncidentId> =
  {
    isResultVisible: (incident) =>
      incident.status_id !== RugbyLeagueEventStatusId.Penalties,
    scoringIncidents: new Map([]),
  }
